import { render, staticRenderFns } from "./OverviewSidebar.vue?vue&type=template&id=3a1b7bce"
import script from "./OverviewSidebar.vue?vue&type=script&lang=ts"
export * from "./OverviewSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports